/** Dates in customer URLs are local calendar days written YYYYMMDD. */

const pad = (n: number) => String(n).padStart(2, '0');

/** 23 Sep 2026 → "20260923". */
export const datePath = (d: Date): string => `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}`;

/** 23 Sep 2026 → "2026-09-23" (the API's date format). */
export const isoDate = (d: Date): string => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

/** "20260923" → local noon on 23 Sep 2026 (noon keeps DST shifts from changing the day), or null. */
export const parseDatePath = (s: string | null | undefined): Date | null => {
  const m = /^(\d{4})(\d{2})(\d{2})$/.exec(s ?? '');
  if (!m) return null;
  const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]), 12);
  return d.getMonth() === Number(m[2]) - 1 ? d : null;
};

/** The date a customer URL is about: the first YYYYMMDD path segment, else today. */
export const dateFromPathname = (pathname: string, now: Date = new Date()): Date => {
  for (const part of pathname.split('/')) {
    const d = parseDatePath(part);
    if (d) return d;
  }
  return new Date(now.getFullYear(), now.getMonth(), now.getDate(), 12);
};

export const addDays = (d: Date, n: number): Date => {
  const out = new Date(d);
  out.setDate(out.getDate() + n);
  return out;
};

export const sameDay = (a: Date, b: Date): boolean => datePath(a) === datePath(b);
